import { useCallback } from 'react';

interface UseCardSizingProps {
  scaleHeight?: string;
  scaleWidth?: string;
}

interface UseCardSizingReturn {
  getElementHeight: (height: number) => number;
  getElementWidth: (width: number) => number;
}

const useCardSizing = ({ scaleHeight, scaleWidth }: UseCardSizingProps): UseCardSizingReturn => {
  const getElementHeight = useCallback(
    (height: number) => {
      if (scaleHeight && Number(scaleHeight) > 0) {
        return height * Number(scaleHeight);
      }
      return height;
    },
    [scaleHeight]
  );

  const getElementWidth = useCallback(
    (width: number) => {
      if (scaleWidth && Number(scaleWidth) > 0) {
        return width * Number(scaleWidth);
      }
      return width;
    },
    [scaleWidth]
  );

  return {
    getElementHeight,
    getElementWidth
  };
};

export default useCardSizing;
